import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  price?: string;
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  href,
  price,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
      return;
    }
    if (onClick) {
      onClick();
    } else {
      const pricingSection = document.getElementById('pricing');
      if (pricingSection) {
        pricingSection.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} animate={{
    boxShadow: ['0 0 0 0 rgba(244, 162, 97, 0)', '0 0 0 10px rgba(244, 162, 97, 0.1)', '0 0 0 20px rgba(244, 162, 97, 0)']
  }} transition={{
    boxShadow: {
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    },
    scale: {
      duration: 0.2
    }
  }} onClick={handleClick} className={`w-full bg-gradient-to-r from-amber-400 to-amber-500 text-night-900 font-bold py-3.5 px-5 rounded-xl text-base shadow-lg flex items-center justify-center gap-2 relative overflow-hidden group ${className}`} data-id="element-1">
      <span className="relative z-10 flex items-center gap-2" data-id="element-2">
        {children}
        {price && <span className="opacity-90 font-normal" data-id="element-3">— {price}</span>}
        <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-4" />
      </span>
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out rounded-xl" data-id="element-5" />
    </motion.button>;
}